export default (name = '', value, validators = null, valid = false) => {
  return {
    name,
    value,
    validators: validators ? validators : {},
    valid: validators ? valid : true
  };
}